import { ref, onMounted } from 'vue'
import { GeneralWrapper } from '@/wrappers'
import type { Documentation } from '@/interfaces'

export function useDocs() {

    const wrapper = new GeneralWrapper();

    const docs = ref<Documentation[]>([]);

    onMounted(() => wrapper.getDocs().then(data => docs.value = data));

    return {
        docs
    };
}